import React from 'react';
import Component from '../../components/Component';
import Datagrid from '../../components/Datagrid';
import Renderers from '../../helpers/Renderers';
import DbInfo from '../../dbinfo';
import c from '../../constants';
import {FormManager} from 'reactis-forms';
import {FilterInput, Select, SearchInput} from 'reactis-inputs';
import {FilterResetButton, FilterField} from 'reactis-datagrid';
import {Button, ButtonToolbar} from 'react-bootstrap';
import {AlertWindow} from 'reactis-modal';
import EventEmitter from '../../EventEmitter';
import DateRange from '../../components/Form/DateRange';
import DocumentTitle from 'react-document-title';
import {connect} from 'react-redux';
import ActiveSelect from '../../components/Form/ActiveSelect';
import {bindActionCreators} from 'redux';
import SectorPicker from '../../components/Form/SectorPicker';
import store from 'store2';

export default class List extends Component {

	static contextTypes = {
		location: React.PropTypes.object
	};

	constructor(props, context) {
		super(props);

		const rendererLink = (val, row) => {
			return <a href={'/etrainingtype/'+row.id} onClick={(e) => this.handleOpen(row, e)}>{val}</a>;
		};

		this.columnModel = [
			{
				name: 'code',
				title: 'Kód',
				field: 'code',
				width: 40
			},
			{
				name: 'title',
				title: 'Název',
				field: 'title',
				renderer: rendererLink
			},
			{
				name: 'abbr',
				title: 'Zkratka',
				field: 'abbr',
				width: 60
			},
			/*{
				name: 'groups',
				title: 'Skupiny',
				field: 'groups',
				width: 175
			},*/
			{
				name: 'price',
				title: 'Cena',
				field: 'price',
				width: 70
			},
			/*{
				name: 'price_praxe',
				title: 'PZ',
				field: 'price_praxe',
				width: 70
			},
			{
				name: 'price_praxe_verify',
				title: 'OPZ',
				field: 'price_praxe_verify',
				width: 70
			},*/
			{
				name: 'praxe',
				title: 'Zácvik',
				field: 'praxe',
				width: 60,
				renderer: Renderers.Check
			},
			{
				name: 're',
				title: 'Opak.',
				field: 're',
				width: 60,
				renderer: Renderers.Check
			},
			{
				name: 'edit',
				title: 'Akce',
				field: 'id',
				width:80,
				sortable: false,
				renderer: (val, row) => {
					return (
						<a href={'/etrainingtype/'+val} onClick={(e) => this.handleOpen(row, e)}>
							<i className="fa fa-pencil position-left"></i>Upravit
						</a>
					);
				}
			}
		];

		const filterSchema = {
			fulltext: { class: SearchInput },
			praxe: { class: Select, options: DbInfo.YesNo },
			re: { class: Select, options: DbInfo.YesNo },
			edit: {
				class: FilterResetButton,
				visible: () => this.filter.isChanged(),
				onClick: () => this.filter.reset()
			}
		};
		this.filter = new FormManager(filterSchema);
		const sessionState = store.session.get('dg-etrainingtype');
		// default
		let filter = {};
		// session
		if (sessionState && sessionState.filter) {
			filter = sessionState.filter;
		}
		this.defaultFilter = filter;
		this.defaultSort = sessionState && sessionState.sort ? sessionState.sort : {column: 'code', 'direction': 'asc'};

	}

	componentDidMount() {
		this.changeListener = () => {
			this.refs.datagrid.getWrappedInstance().refresh();
		};
		EventEmitter.on('etrainingtype.change', this.changeListener);
	}

	componentWillUnmount() {
		EventEmitter.removeListener('etrainingtype.change', this.changeListener);
	}

	handleOpen(row, e) {
		e.preventDefault();
		this.props.actions.openTabForm('etrainingtype', row.t, row);
	}

	handleNewClick(e) {
		e.preventDefault();
		this.props.newTab();
	}

	render() {

		const buttons = <Button href="/etrainingtype/0" onClick={(e) => this.handleNewClick(e)}>
			<i className="fa fa-plus position-left"/>Nový druh
		</Button>;

		return (
			<Datagrid
				ref="datagrid"
				id="etrainingtype"
				api="etrainingtype.getList"
				buttons={buttons}
				filters={['fulltext']}
				filter={this.filter}
				saveState={true}
				getRowClassName={null}
				columnModel={this.columnModel}
				defaultFilter={this.defaultFilter}
				forceFilter={this.filterUrl}
				defaultSort={this.defaultSort}
			/>
		)
	}
}



// WEBPACK FOOTER //
// ./src/containers/Etrainingtype/List.js